export default __webpack_public_path__ + "static/media/emailbtn.664e11e8.png";